<script>
import { get_role_user_page, add_role_user, delete_role_user } from '@/api/enterprise'
import { exportExcel } from '@/api/common'
export default {
  name: 'RoleUserData',
  components: {}, // 角色用户数据
  props: {
    roleUuid: {
      type: String,
      default: ''
    },
    roleTypeCode: {
      type: Number,
      default: null
    },
    readOnlyFlag: {
      type: [Boolean, Number],
      default: false
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      keywords: '',
      page: {
        pageNum: 1,
        pageSize: 10
      },
      tableTotal: 0
    }
  },
  computed: {
    disabled() {
      return this.roleTypeCode !== 1003502 // 角色组类型
    }
  },
  watch: {
    roleUuid: {
      handler() {
        this.getRoleUser()
      },
      immediate: true
    }
  },
  created() {},
  methods: {
    async getRoleUser(status) {
      this.tableData=[]
      try {
        if (status !== 'page') {
          this.page.pageNum = 1
        }
        this.loading = true
        const result = await get_role_user_page({
          keyword: this.keywords,
          roleUuid: this.roleUuid,
          page: this.page
        })
        this.tableData = result.data.list
        this.tableTotal = result.data.page.total
      } catch (e) {

      } finally {
        this.loading = false
      }
    },
    async deleteUser(data) {
      let load = null
      try {
        await this.$confirm(`${data.userName}`, '是否确认删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'message-dialog',
          type: 'warning',
          center: true
        })
        load = this.$load()
        await delete_role_user({
          roleUuid: this.roleUuid,
          userUuidList: [data.userUuid]
        })
        load.close()
        this.$message.success('操作成功')
        await this.getRoleUser()
      } catch (e) {
        load?.close()
      }
    },
    addUser() {
      this.$selectUser({
        searchTip: '请输入用户姓名',
        title: '添加角色组成员',
        value: [], // 用来回显使用
        limit: 0,
        type: 2,
        authType: 0,
        userCountFlag: 0,
        changeHandler: (result, showList) => {
          if (result.length == 0) {
            this.$message({
              type: 'warning',
              message: '请选择人员!'
            })
            return false
          }
          add_role_user({
            roleUuid: this.roleUuid,
            userUuidList: result
          }).then(d => {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            this.getRoleUser()
          }).finally(_ => {
          }).catch(e => {
            this.$errorHandle(e)
          })
        }
      })
    },
    async exportAuth() {
      const load = this.$load()
      try {
        const res = await exportExcel({
          progressParamData: { roleUuid: this.roleUuid },
          excelPath: '',
          progressBusinessCode: 1306202
        })
        this.$refs.export.operateProgressId = res.data.progressId
      } catch (e) {

      } finally {
        load.close()
      }
    }
  }
}
</script>

<template>
  <div class="role-user-data">
    <el-row class="role-user-data-option" :gutter="20">
      <el-col :span="8">
        <el-input v-model="keywords" placeholder="请输入用户姓名/手机号" clearable prefix-icon="el-icon-search" @clear="getRoleUser()" />
      </el-col>
      <el-col :span="12">
        <el-button type="primary" icon="el-icon-search" @click="getRoleUser()">搜 索</el-button>
        <el-button v-permission="['11203040205']" type="primary" :disabled="disabled" icon="el-icon-circle-plus-outline" @click="addUser()">添加用户</el-button>
        <!--        <el-button type="primary" icon="el-icon-download" @click="exportAuth">导 出</el-button>-->
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="tableData" height="300px">
      <el-table-column prop="xh" label="序号" width="80" />
      <el-table-column prop="userName" label="姓名" width="180">
        <template #default="{ row }">
          <span>{{ row.userName }}</span>
          <span v-if="row.enterpriseFounderFlag === 1" class="m_management_founder">创建人</span>
        </template>
      </el-table-column>
      <el-table-column prop="phoneNumber" label="手机号" width="180">
        <template #default="{ row }">
          <um-phone-display
            :phone-number="row.userMobile"
            :permissions="['112030402011']"
            :params="{orgUserId:row.userId,selectType:1}"
            list-api="/api/v1/organ/dataDesensitization/orgUser/info"
          />
        </template>
      </el-table-column>
      <el-table-column prop="userDepartment" label="部门" min-width="180">
        <template #default="{ row }">
          <UmToolTip :content="row.userDepartment" class="row_2" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template #default="{ row }">
          <el-button v-if="row.enterpriseFounderFlag !== 1" v-permission="['11203040206']" type="text" class="m_management_shanchu" @click="deleteUser(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :background="false"
      :total="tableTotal"
      :page.sync="page.pageNum"
      :limit.sync="page.pageSize"
      :layout="'total, sizes, prev, pager, next, jumper'"
      @pagination="getRoleUser('page')"
    />
  </div>
</template>

<style scoped lang="scss">
.role-user-data{
  padding-top: 15px;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.role-user-data-option{
  margin-bottom: 15px;
}
.m_management_shanchu {
  color: #fd5050;
}
</style>
